import React from "react";
import { Route, Redirect } from "react-router-dom";

import Web3Provider from "./network";

import { SnackbarProvider } from "notistack";

import Footer from "./Footer/Footer";
import NarBar from "./NavBar/NavBar.jsx";
import Withdraw from "./Withdraw/Withdraw";
import Terms from "./StaticPages/Terms.jsx";
import Liquidity from "./Liquidity/Liquidity";
import Stacking from "./Staking/Stacking.jsx";
import Privacy from "./StaticPages/Privacy.jsx";
import CoinSwapper from "./CoinSwapper/CoinSwapper";
import CommingSoonPage from "./Components/commingSoonPage";
import UpdateStaking from "./Staking/admin/UpdateStaking.jsx";
import CreateStakingPool from "./Staking/admin/CreateStakingPool.jsx";
import Invest from "./Invest/Invest.jsx";
import NFTPools from "./NFT/NFTPools";
import MyNFTs from "./NFT/MyNFTs";
import MyNFTDetail from "./NFT/MyNFTDetail";
import NFTPoolDetail from "./NFT/NFTPoolDetail";

import "./App.css";

const App = () => {
  return (
    <SnackbarProvider maxSnack={3}>
      <Web3Provider
        render={(network, darkMode, onChangeDarkMode) => (
          <>
            <NarBar
              network={network}
              darkMode={darkMode}
              onChange={onChangeDarkMode}
            />

            <Route exact path="/">
              <Redirect to="/swap" />
            </Route>
            <Route path="/swap">
              <CoinSwapper network={network} />
            </Route>

            <Route path="/liquidity">
              <Liquidity network={network} />
            </Route>

            <Route path="/staking-pools">
              <Stacking network={network} type="token" />
            </Route>

            <Route path="/withdarw-lp-tokens">
              <Withdraw network={network} />
            </Route>

            <Route path="/staking-farms">
              <Stacking network={network} type="lptoken" />
            </Route>

            <Route path="/create-staking-pool">
              <CreateStakingPool network={network} />
            </Route>

            <Route path="/update-staking-pool">
              <UpdateStaking network={network} />
            </Route>

            <Route path="/invest">
              <Invest network={network} />
            </Route>

            <Route path="/nft-pools">
              <NFTPools network={network} />
            </Route>

            <Route path="/nft-pools-detail/:contract">
              <NFTPoolDetail network={network} />
            </Route>

            <Route path="/my-nfts">
              <MyNFTs network={network} />
            </Route>

            <Route path="/my-nfts-detail/:contract/:id">
              <MyNFTDetail network={network} />
            </Route>

            <Route path="/lottery">
              <CommingSoonPage darkMode={darkMode} />
            </Route>

            <Route path="/bridge">
              <CommingSoonPage darkMode={darkMode} />
            </Route>

            <Route path="/terms">
              <Terms />
            </Route>

            <Route path="/privacy">
              <Privacy />
            </Route>

            <Footer />
          </>
        )}
      ></Web3Provider>
    </SnackbarProvider>
  );
};

export default App;
